"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var React = __importStar(require("react"));

var PropTypes = __importStar(require("prop-types"));

var SafeAsyncComponent_1 = __importStar(require("./SafeAsyncComponent"));

var resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));

var withTheme_1 = require("../utils/withTheme");

var BreakpointWidthMap = {
  'extra-small': 0,
  small: 400,
  medium: 600,
  large: 990
};

var BreakpointObserver =
/** @class */
function (_super) {
  __extends(BreakpointObserver, _super);

  function BreakpointObserver() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.resizeObserver = null;
    _this.container = null;
    return _this;
  }

  BreakpointObserver.prototype.shouldComponentUpdate = function (nextProps) {
    return this.props.onChange !== nextProps.onChange;
  };

  BreakpointObserver.prototype.safeComponentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (this.container) {
          this.resizeObserver = new resize_observer_polyfill_1["default"](this._onResize);
          this.resizeObserver && this.resizeObserver.observe(this.container);
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  BreakpointObserver.prototype.safeComponentWillUnmount = function () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  };

  BreakpointObserver.prototype.render = function () {
    var _this = this;

    return withTheme_1.withTheme(this.context.theme, 'breakpoint-observer')(React.createElement("div", {
      ref: function ref(_ref) {
        return _this.container = _ref;
      }
    }));
  };

  BreakpointObserver.prototype._onResize = function (entries, observer) {
    var width = entries[0].contentRect.width;

    if (width >= BreakpointWidthMap.large) {
      this.props.onChange('large', width);
    } else if (width >= BreakpointWidthMap.medium) {
      this.props.onChange('medium', width);
    } else if (width >= BreakpointWidthMap.small) {
      this.props.onChange('small', width);
    } else {
      this.props.onChange('extra-small', width);
    }
  };

  BreakpointObserver.contextTypes = __assign({}, SafeAsyncComponent_1["default"].contextTypes, {
    theme: PropTypes.object
  });

  __decorate([SafeAsyncComponent_1.bindCallback], BreakpointObserver.prototype, "_onResize");

  return BreakpointObserver;
}(SafeAsyncComponent_1["default"]);

exports["default"] = BreakpointObserver;